import Vue from "vue";

window.jQuery = window.$ = require('jquery');
var $ = window.jQuery;
import PerfectScrollbar from 'perfect-scrollbar';

require('./bootstrap');
require('bootstrap');
window.Vue = require('vue');
import vuetify from './plugins/vuetify';

/** importati da voyager **/
window.perfectScrollbar = require('perfect-scrollbar/jquery')($);
window.Cropper = require('cropperjs');
window.Cropper = 'default' in window.Cropper ? window.Cropper['default'] : window.Cropper;
window.toastr = require('toastr');
window.DataTable = require('datatables');
require('datatables-bootstrap3-plugin/media/js/datatables-bootstrap3');
window.EasyMDE = require('easymde');
require('dropzone');
require('jquery-match-height');
require('bootstrap-toggle');
require('nestable2');
require('bootstrap');
require('bootstrap-switch');
require('select2');
require('eonasdan-bootstrap-datetimepicker/src/js/bootstrap-datetimepicker');
var brace = require('brace');
require('brace/mode/json');
require('brace/theme/github');
require('./slugify');
require('./multilingual');
require('./voyager_tinymce');
window.voyagerTinyMCE = require('./voyager_tinymce_config');
require('./voyager_ace_editor');
window.helpers = require('./helpers.js');
require('./course-association-picker');
/** fine importazione **/


import loading from 'vuejs-loading-screen';
import {VTooltip, VPopover, VClosePopover} from 'v-tooltip'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

var _ = require('lodash');
var axios = require('axios');
window.toastr = require('toastr');
require('jquery-match-height');
require('bootstrap-toggle');
window.memoizeDebounce = function (func, wait = 0, options = {}) {
    var mem = _.memoize(function () {
        return _.debounce(func, wait, options)
    }, options.resolver);
    return function () {
        mem.apply(this, arguments).apply(this, arguments)
    }
};
window.privateHelpers = {
    refreshFileList: window.memoizeDebounce(function (key, event, endpoint) {
        console.log('fine di tutto', key, endpoint, event);
        let uniqueKey = key;
        let container = "." + key + ".files";
        $(container).removeClass('hide');
        let lastText = "." + key + ".files .last h5";
        let items = "." + key + ".files div.file";
        $(lastText).text('');
        console.log('qui dovresti aver aggiornato', container)
        $('#' + uniqueKey + ' div.waiting')
            .removeClass('hide')
            .css('display', 'none');
        $('#' + uniqueKey + ' button.button')
            .removeClass('hide')
            .css('display', 'block');
        axios.post(endpoint, {"unique": key, 'event': event})
            .then((r) => {
                $(items).map((i, v) => {
                    $(v).remove();
                });
                $(lastText).text('');
                if (r.data && r.data.files) {
                    $(lastText).text('Ultimo aggiornamento ' + r.data.last);

                    r.data.files.map((file) => {
                        let divo = $('<div>');
                        divo.addClass('col-md-6 file');
                        let ancora = $('<a>');
                        ancora.attr('target', '_blank');
                        ancora.attr('download', file.name);
                        ancora.prop('target', '_blank');
                        ancora.prop('download', file.name);
                        ancora.html(
                            file.name + "(generato il " + file.last + ") " +
                            '<i class="glyphicon glyphicon-chevron-right"></i>'
                        );
                        ancora.attr('href', file.file);
                        ancora.prop('href', file.file);
                        divo.append(ancora);
                        $(container).append(divo);
                    });
                }
            })
            .catch((e) => {
                console.error("errore", e);
            });
        //svuota items
        //Aggiorna lastText
        //inserisci nuovi items
        console.log('richiedi update dei file --- fine di tutto', key, endpoint);
    }, 300),
    updateInterface: window.memoizeDebounce(function (key, evt, status, progress) {
        let uniqueKey = key;
        let _progress = Math.round(evt.progress);
        $('#' + uniqueKey + ' span.text')
            .text(_progress + "%");
        if (status === 'finished' || status === 'failed') {
            $('#' + uniqueKey + ' div.waiting')
                .removeClass('hide')
                .css('display', 'block');
            $('#' + uniqueKey + ' button.button')
                .removeClass('hide')
                .css('display', 'none');
        } else {
            $('#' + uniqueKey + ' div.waiting')
                .removeClass('hide')
                .css('display', 'block');
            $('#' + uniqueKey + ' button.button')
                .removeClass('hide')
                .css('display', 'none');
        }
        if (status === 'finished') {
            console.log('request file list per uniqueKey', uniqueKey);
            window.ifaHelpers.refreshFileList(uniqueKey, evt, window.ifaHelpers.endpoint);
        }
        if (status === 'failed') {
            toastr.error('Spiecenti si  verificato un errore');
            $('#' + uniqueKey + ' div.waiting')
                .removeClass('hide')
                .css('display', 'none');
            $('#' + uniqueKey + ' button.button')
                .removeClass('hide')
                .css('display', 'block');
        }
    }, 200)
}
window.ifaHelpers = {
    endpoint: false,
    initGenerators: function () {
        $('form.generators').on('submit', function (evt) {
            var data = {};
            var uniqueMe = $(this).data('reportkey');
            var $form = $(evt.target);
            var arr = $form.serializeArray(); // an array of all form items
            for (var i = 0; i < arr.length; i++) { // transforming the array to object
                data[arr[i].name] = arr[i].value;
            }
            let submitter = evt.submitter;
            if (submitter) {
                data[$(submitter).attr('name')] = $(submitter).attr('action');
            }
            console.log('avvio form', uniqueMe, data, arr, submitter);
            data.return_type = "json";
            $('#' + uniqueMe + ' span.text')
                .text("Avvio in corso");
            $('#' + uniqueMe + ' div.waiting')
                .removeClass('hide')
                .css('display', 'block');
            $('#' + uniqueMe + ' button.button')
                .removeClass('hide')
                .css('display', 'none');

            $.ajax({
                url: $form.attr('action') || document.URL,
                type: $form.attr('method') || 'post',
                dataType: 'json',
                data: data
            }).done(function (response) {
                console.log("data handled on server - response:", response);
                let error = false;
                if (response && response.error === true) {
                    error = true;
                }
                if (error === false) {
                    $('#' + uniqueMe + ' span.text')
                        .text("0%");
                    $('#' + uniqueMe + ' div.waiting')
                        .removeClass('hide')
                        .css('display', 'block');
                    $('#' + uniqueMe + ' button.button')
                        .css('display', 'none');
                } else {
                    alert('si è verificato un errore');
                    $('#' + uniqueMe + ' span.text')
                        .text("Avvio in corso");
                    $('#' + uniqueMe + ' div.waiting')
                        .removeClass('hide')
                        .css('display', 'none');
                    $('#' + uniqueMe + ' button.button')
                        .css('display', 'block');
                }
                console.log('cambio layout', error, uniqueMe);
                if (response && response.messages && response.messages.alerts) {
                    for (let i = 0; i < response.messages.alerts.length; i++) {
                        let toastManager = toastr[response.messages.alerts[i].type];
                        toastManager(response.messages.alerts[i].message);
                    }
                }

            }).fail(function () {
                alert("Server connection failed!");
            });
            return false;
        });
    },
    refreshFileList: function (key, evt, endpoint) {
        window.privateHelpers.refreshFileList(key, evt, endpoint);
    },
    updateInterface: function (key, evt, status, progress) {
        window.privateHelpers.updateInterface(key, evt, status, progress);
    }
};
Vue.use(VTooltip);
Vue.component('calendar', require('./components/calendar.vue').default);
Vue.component('calendarv2', require('./components/calendarv2/CalendarEditorV2.vue').default);
Vue.component('calendar-planner', require('./components/calendar-planner/CalendarPlanner.vue').default);
Vue.component('communication-composer', require('./components/communications/CommunicationComposer.vue').default);
Vue.component('disponibilita', require('./components/disponibilita.vue').default);
Vue.component('progetto-field', require('./components/progetto-field.vue').default);
Vue.component('bandoallegati-field', require('./components/bandoallegati-field.vue').default);
Vue.component('corsi-field', require('./components/corsi-field.vue').default);
Vue.component('admin-menu', require('./components/admin_menu.vue').default);
Vue.component('imputazioni', require('./components/imputazioni').default);
Vue.component('multi-imputazioni', require('./components/multi_imputazioni').default);
Vue.use(loading, {
    bg: '#012e5ead',
    icon: 'refresh',
    size: 3,
    icon_color: 'white',
});

Vue.prototype.$isMobile = function () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
    } else {
        return false
    }
};

Vue.prototype.$humanFilesize = function (size) {
    var i = Math.floor(Math.log(size) / Math.log(1024));
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

const appManagersVue = document.querySelectorAll(".vueManagers");
const each = Array.prototype.forEach;
let data = {
    "managed": true,
    "calendarV2Config": window.calendarV2Config || null,
    "calendarPlannerConfig": window.calendarPlannerConfig || null
};
// Use v-calendar & v-date-picker components
Vue.component('v-calendar', Calendar);
Vue.component('v-date-picker', DatePicker);
Vue.directive('tooltip', VTooltip)
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)
//each.call(appManagersVue, (el, index) => new Vue({el:el, vuetify: vuetify, data:data}));
each.call(appManagersVue, (el, index) =>
    new Vue({
        vuetify: vuetify,
        data: data,
        methods: {
            /**
             * generateUniqueHash genera un codice univoco da una stringa
             * @param object:any
             * @returns {number}
             */
            generateUniqueHash(object) {
                var str = JSON.stringify(object)
                var hash = 0;
                if (str.length == 0) return hash;
                for (let i = 0; i < str.length; i++) {
                    let char = str.charCodeAt(i);
                    hash = ((hash << 5) - hash) + char;
                    hash = hash & hash;
                }
                return hash;
            },
            /**
             * storeObject  Conserva in localStorage un oggetto per chiave
             * @param key:string Chiave da salvare
             * @param value:any oggetto da conservare
             * @param ttl:number durata dell'oggetto in cache, valore di default 86400(1g)
             */
            storeObject(key, value, ttl = 86400) {
                const now = new Date();
                const item = {
                    value: value,
                    expiry: now.getTime() + (ttl * 1000),
                };
                localStorage.setItem(key, JSON.stringify(item));
            },
            /**
             * retrieveObject  Conserva in localStorage un oggetto per chiave
             * @param key
             * @returns {null|*}
             */
            retrieveObject(key) {
                const itemStr = localStorage.getItem(key);
                if (!itemStr) {
                    return null;
                }
                const item = JSON.parse(itemStr);
                const now = new Date();
                if (now.getTime() > item.expiry) {
                    console.log('cache key is expired', key);
                    localStorage.removeItem(key)
                    return null;
                }
                return item.value;
            }
        },
        mounted() {
            console.log('init Vue');
            window.mainV = this;
            $('#voyager-loader').remove();
        }
    }).$mount(el)
);

$(document).ready(function () {

    var appContainer = $(".app-container"),
        fadedOverlay = $('.fadetoblack'),
        hamburger = $('.hamburger');


    $('.side-menu').perfectScrollbar();
    //new PerfectScrollbar('.side-menu', {});

    $('#voyager-loader').fadeOut();

    $(".hamburger, .navbar-expand-toggle").on('click', function () {
        appContainer.toggleClass("expanded");
        $(this).toggleClass('is-active');
        if ($(this).hasClass('is-active')) {
            window.localStorage.setItem('voyager.stickySidebar', true);
        } else {
            window.localStorage.setItem('voyager.stickySidebar', false);
        }
    });


    $('select.select2').select2({width: '100%'});

    /**
     * Mantiene coerenti i tre campi di residenza delle anagrafiche:
     * Regione -> Provincia -> Comune.
     *
     * Il componente si attiva solo nei form che espongono tutti i campi
     * address_*, quindi non cambia il comportamento degli altri dropdown
     * provincia presenti nell'amministrazione.
     */
    $('select[data-provinces-by-region]').each(function () {
        const provinceSelect = this;
        const form = provinceSelect.form ? $(provinceSelect.form) : $(document);
        const regionSelect = form.find('select[name="address_neib"]');
        const citySelect = form.find('select[name="address_city"]');

        if (regionSelect.length !== 1 || citySelect.length !== 1) {
            return;
        }

        const provinceApiTemplate = $(provinceSelect).data('provinces-by-region');
        const initialProvince = provinceSelect.value;
        let knownProvince = initialProvince;
        let requestSequence = 0;

        const clearCity = function () {
            citySelect.val(null).empty().trigger('change');
        };

        const notifyProvinceChanged = function () {
            provinceSelect.dispatchEvent(new Event('change', {bubbles: true}));
        };

        const loadProvinces = function (region, provinceToKeep, shouldClearCity) {
            const requestId = ++requestSequence;
            const normalizedRegion = $.trim(region || '');

            $(provinceSelect).prop('disabled', true);
            if (shouldClearCity) {
                clearCity();
                citySelect.prop('disabled', true);
            }

            if (normalizedRegion === '') {
                $(provinceSelect)
                    .empty()
                    .append(new Option('Seleziona prima la regione', '', true, true))
                    .prop('disabled', false)
                    .trigger('change.select2');
                notifyProvinceChanged();
                return;
            }

            const encodedRegion = encodeURIComponent(normalizedRegion);
            const encodedRegionPlaceholder = encodeURIComponent('###REGION###');
            const url = provinceApiTemplate.includes('###REGION###')
                ? provinceApiTemplate.replace('###REGION###', encodedRegion)
                : provinceApiTemplate.replace(encodedRegionPlaceholder, encodedRegion);

            $.getJSON(url).done(function (provinceList) {
                if (requestId !== requestSequence) {
                    return;
                }

                const selectedExists = provinceList.some(function (province) {
                    return String(province.id) === String(provinceToKeep || '');
                });

                $(provinceSelect)
                    .empty()
                    .append(new Option('Seleziona la provincia', '', !selectedExists, !selectedExists));

                provinceList.forEach(function (province) {
                    const selected = selectedExists && String(province.id) === String(provinceToKeep);
                    $(provinceSelect).append(new Option(province.text, province.id, selected, selected));
                });

                $(provinceSelect).prop('disabled', false).trigger('change.select2');
                citySelect.prop('disabled', !selectedExists);

                if (!selectedExists) {
                    clearCity();
                }

                // Aggiorna l'URL remoto del Comune una sola volta, dopo che
                // le opzioni della Provincia sono state ricostruite.
                notifyProvinceChanged();
            }).fail(function () {
                if (requestId === requestSequence) {
                    $(provinceSelect).prop('disabled', false);
                    toastr.error('Non è stato possibile caricare le province della regione selezionata.');
                }
            });
        };

        regionSelect.on('change.addressLocality', function () {
            loadProvinces(this.value, null, true);
        });

        $(provinceSelect).on('change.addressLocality', function () {
            if (knownProvince !== this.value) {
                knownProvince = this.value;
                clearCity();
                citySelect.prop('disabled', this.value === '');
            }
        });

        loadProvinces(regionSelect.val(), initialProvince, false);
    });

    $('select.select2-ajax').each(function () {
        let minimumInputLenght =  $(this).data('minimum');
        if(typeof minimumInputLenght !=='undefined' && minimumInputLenght!=="") {
            minimumInputLenght = parseInt(minimumInputLenght);
        }
        if(isNaN(minimumInputLenght)) {
            minimumInputLenght = 3;
        }

        let options = {
            language: {
                errorLoading: function () {
                    return 'I risultati non possono essere caricati.';
                },
                inputTooLong: function (args) {
                    var overChars = args.input.length - args.maximum;

                    var message = 'Per favore cancella ' + overChars + ' caratter';

                    if (overChars !== 1) {
                        message += 'i';
                    } else {
                        message += 'e';
                    }

                    return message;
                },
                inputTooShort: function (args) {
                    var remainingChars = args.minimum - args.input.length;

                    var message = 'Per favore inserisci ' + remainingChars + ' o più caratteri';

                    return message;
                },
                loadingMore: function () {
                    return 'Caricamento altri risultati…';
                },
                maximumSelected: function (args) {
                    var message = 'Puoi selezionare solo ' + args.maximum + ' element';

                    if (args.maximum !== 1) {
                        message += 'i';
                    } else {
                        message += 'o';
                    }

                    return message;
                },
                noResults: function () {
                    return 'Nessun risultato trovato';
                },
                searching: function () {
                    return 'Sto cercando…';
                },
                removeAllItems: function () {
                    return 'Rimuovi tutti gli oggetti';
                },
                removeItem: function () {
                    return 'Rimuovi oggetto';
                },
                search: function () {
                    return 'Ricerca';
                }
            },
            minimumInputLength:minimumInputLenght,
            width: '100%',
            dropdownParent: $(this).hasClass('parentboxed') ? $(this).data('parent') : null,
            ajax: {
                url: typeof (window["requestCurrentAjaxUrl"]) === 'function' ? window.requestCurrentAjaxUrl(this) : $(this).data('get-items-route'),
                data: function (params) {
                    var query = {
                        search: params.term,
                        type: $(this).data('get-items-field'),
                        params: $(this).data('get-items-params'),
                        method: $(this).data('method'),
                        id: $(this).data('id'),
                        page: params.page || 1
                    }
                    return query;
                }
            }
        };
        if ($(this).data('allownew') == '1' || $(this).data('allownew') == 1) {
            options.tags = true;
            options.createTag = function (params) {
                var term = $.trim(params.term);
                if (term === '') {
                    return null;
                }
                return {
                    id: term,
                    text: term,
                    newTag: true
                }
            }
        }
        $(this).select2(options);
        $(this).on('select2:select', function (e) {
            var data = e.params.data;
            if (data.id == '') {
                // "None" was selected. Clear all selected options
                $(this).val([]).trigger('change');
                const event = new CustomEvent('select2Picked', {detail: {editor: this, data: null}});
                document.dispatchEvent(event)
            } else {
                const event = new CustomEvent('select2Picked', {detail: {editor: this, data: data}});
                document.dispatchEvent(event)
                $(e.currentTarget).find("option[value='" + data.id + "']").attr('selected', 'selected');
            }
        });
        $(this).on('select2:unselect', function (e) {
            var data = e.params.data;
            $(e.currentTarget).find("option[value='" + data.id + "']").attr('selected', false);
            $(this).val([]).trigger('change');
            const event = new CustomEvent('select2Picked', {detail: {editor: this, data: null}});
            document.dispatchEvent(event)
        });
        console.log('appendo eventi? ', this);
        const reinitSelect2 = function(item) {
            $(item).select2('destroy');
            let options = {
                language: {
                    errorLoading: function () {
                        return 'I risultati non possono essere caricati.';
                    },
                    inputTooLong: function (args) {
                        var overChars = args.input.length - args.maximum;

                        var message = 'Per favore cancella ' + overChars + ' caratter';

                        if (overChars !== 1) {
                            message += 'i';
                        } else {
                            message += 'e';
                        }

                        return message;
                    },
                    inputTooShort: function (args) {
                        var remainingChars = args.minimum - args.input.length;

                        var message = 'Per favore inserisci ' + remainingChars + ' o più caratteri';

                        return message;
                    },
                    loadingMore: function () {
                        return 'Caricamento altri risultati…';
                    },
                    maximumSelected: function (args) {
                        var message = 'Puoi selezionare solo ' + args.maximum + ' element';

                        if (args.maximum !== 1) {
                            message += 'i';
                        } else {
                            message += 'o';
                        }

                        return message;
                    },
                    noResults: function () {
                        return 'Nessun risultato trovato';
                    },
                    searching: function () {
                        return 'Sto cercando…';
                    },
                    removeAllItems: function () {
                        return 'Rimuovi tutti gli oggetti';
                    },
                    removeItem: function () {
                        return 'Rimuovi oggetto';
                    },
                    search: function () {
                        return 'Ricerca';
                    }
                },
                width: '100%',
                dropdownParent: $(item).hasClass('parentboxed') ? $(item).data('parent') : null,
                ajax: {
                    url: typeof (window["requestCurrentAjaxUrl"]) === 'function' ? window.requestCurrentAjaxUrl(item) : $(item).data('get-items-route'),
                    data: function (params) {
                        var query = {
                            search: params.term,
                            type: $(item).data('get-items-field'),
                            params: $(item).data('get-items-params'),
                            method: $(item).data('method'),
                            id: $(item).data('id'),
                            page: params.page || 1
                        }
                        return query;
                    }
                }
            };
            if ($(item).data('allownew') == '1' || $(item).data('allownew') == 1) {
                options.tags = true;
                options.createTag = function (params) {
                    var term = $.trim(params.term);
                    if (term === '') {
                        return null;
                    }
                    return {
                        id: term,
                        text: term,
                        newTag: true
                    }
                }
            }
            $(item).select2(options);
            $(item).on('select2:select', function (e) {
                var data = e.params.data;
                if (data.id == '') {
                    // "None" was selected. Clear all selected options
                    $(item).val([]).trigger('change');
                    const event = new CustomEvent('select2Picked', {detail: {editor: item, data: null}});
                    document.dispatchEvent(event)
                } else {
                    const event = new CustomEvent('select2Picked', {detail: {editor: item, data: data}});
                    document.dispatchEvent(event)
                    $(e.currentTarget).find("option[value='" + data.id + "']").attr('selected', 'selected');
                }
            });
            $(item).on('select2:unselect', function (e) {
                var data = e.params.data;
                $(e.currentTarget).find("option[value='" + data.id + "']").attr('selected', false);
                $(item).val([]).trigger('change');
                const event = new CustomEvent('select2Picked', {detail: {editor: item, data: null}});
                document.dispatchEvent(event)
            });
        }

        this.addEventListener('relatedChange',function() {
            reinitSelect2(this);
        });
    });
    $('select.select2-taggable').select2({
        width: '100%',
        tags: true,
        createTag: function (params) {
            var term = $.trim(params.term);

            if (term === '') {
                return null;
            }

            return {
                id: term,
                text: term,
                newTag: true
            }
        }
    }).on('select2:selecting', function (e) {
        var $el = $(this);
        var route = $el.data('route');
        var label = $el.data('label');
        var errorMessage = $el.data('error-message');
        var newTag = e.params.args.data.newTag;

        if (!newTag) return;

        $el.select2('close');

        $.post(route, {
            [label]: e.params.args.data.text,
            _tagging: true,
        }).done(function (data) {
            var newOption = new Option(e.params.args.data.text, data.data.id, false, true);
            $el.append(newOption).trigger('change');
        }).fail(function (error) {
            toastr.error(errorMessage);
        });

        return false;
    }).on('select2:select', function (e) {
        if (e.params.data.id == '') {
            // "None" was selected. Clear all selected options
            $(this).val([]).trigger('change');
        }
    });

    $('.match-height').matchHeight();

    $(".side-menu .nav .dropdown").on('show.bs.collapse', function () {
        return $(".side-menu .nav .dropdown .collapse").collapse('hide');
    });

    $('.panel-collapse').on('hide.bs.collapse', function (e) {
        var target = $(e.target);
        if (!target.is('a')) {
            target = target.parent();
        }
        if (!target.hasClass('collapsed')) {
            return;
        }
        e.stopPropagation();
        e.preventDefault();
    });

    $(document).on('click', '.panel-heading a.panel-action[data-toggle="panel-collapse"]', function (e) {
        e.preventDefault();
        var $this = $(this);

        // Toggle Collapse
        if (!$this.hasClass('panel-collapsed')) {
            $this.parents('.panel').find('.panel-body').slideUp();
            $this.addClass('panel-collapsed');
            $this.removeClass('voyager-angle-up').addClass('voyager-angle-down');
        } else {
            $this.parents('.panel').find('.panel-body').slideDown();
            $this.removeClass('panel-collapsed');
            $this.removeClass('voyager-angle-down').addClass('voyager-angle-up');
        }
    });

    //Toggle fullscreen
    $(document).on('click', '.panel-heading a.panel-action[data-toggle="panel-fullscreen"]', function (e) {
        e.preventDefault();
        var $this = $(this);
        if (!$this.hasClass('voyager-resize-full')) {
            $this.removeClass('voyager-resize-small').addClass('voyager-resize-full');
        } else {
            $this.removeClass('voyager-resize-full').addClass('voyager-resize-small');
        }
        $this.closest('.panel').toggleClass('is-fullscreen');
    });

    $('.datepicker').datetimepicker();

    // Save shortcut
    $(document).keydown(function (e) {
        if ((e.metaKey || e.ctrlKey) && e.keyCode == 83) { /*ctrl+s or command+s*/
            $(".btn.save").click();
            e.preventDefault();
            return false;
        }
    });

    /********** MARKDOWN EDITOR **********/

    $('textarea.easymde').each(function () {
        var easymde = new EasyMDE({
            element: this
        });
        easymde.render();
    });

    /********** END MARKDOWN EDITOR **********/

});
